import { render } from "./signUp3.vue?vue&type=template&id=8ad09432&scoped=true"
import script from "./signUp3.vue?vue&type=script&lang=js"
export * from "./signUp3.vue?vue&type=script&lang=js"

import "./signUp3.vue?vue&type=style&index=0&id=8ad09432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad09432"]])

export default __exports__